import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useMemo, useState } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import ShopApplyForm from "@/pages/checkout/shop-apply/shopApplyForm/ShopApplyForm";
import PaymentInfo from "@/pages/checkout/components/PaymentInfo/PaymentInfo";
import NDayGuarantee from "@/pages/checkout/components/NDayGuarantee/NDayGuarantee";
import { CDN_LINK } from "@globalConfig";
import stl from "./ShopApply.module.css";
import { useTranslation } from "@i18n";
import HeadingSteps from "@/pages/checkout/shop-apply/shopApplyForm/HeadingSteps/HeadingSteps";
import { handleHasAccountEvent } from "@/utils/common";
import { useLang } from "@/common/Contexts/LanguageContext";
import CancelButton from "../../../components/UiKit/Buttons/CancelButton/CancelButton";
import MobileHeaderwithCancleFunction from "@/_LayoutsRelated/mobileHeaders/mobileHeaderwithCancleFunction/MobileHeaderwithCancleFunction";
import OtpVerification from "@/_MiniApps/auth/ui/OTP/OtpVerification";
import useHelpers from "@hooks/useHelpers";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useLocalStorage from "@hooks/useLocalStorage";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import Loader from "@componentsShared/Loader/Loader";
import { normalizeIdNumber } from "@/utils/stringHelpers";
import useIsMobile from "@hooks/useIsMobile";
import useBoolean from "@hooks/useBoolean";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { useAbandonmentTracking } from "@/common/Contexts/AbandonmentTrackingContext";
import { trackEvents } from "@/common/events/events";
import useCookieClient from "@hooks/useCookieClient";
var ShopApply = function ShopApply() {
  if (__IS_SSR__) return /*#__PURE__*/React.createElement(Loader, null);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var _useState = useState(false),
    showOtp = _useState[0],
    setShowOtp = _useState[1];
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrder = _useCheckoutOrder$sta.checkoutOrder,
    formData = _useCheckoutOrder$sta.formData,
    fetch_loading = _useCheckoutOrder$sta.fetch_loading,
    referralData = _useCheckoutOrder$sta.referralData;
  var post_id = useCheckoutOrder().queryParams.post_id;
  var setFormItem = useCheckoutOrder().actions.setFormItem;
  var _useCheckoutOrder$rem = useCheckoutOrder().remote_actions,
    fetch__getOrderWithPaymentInfo = _useCheckoutOrder$rem.fetch__getOrderWithPaymentInfo,
    fetch__getOrderDetailsByParams = _useCheckoutOrder$rem.fetch__getOrderDetailsByParams;
  var grantedPopup = useBoolean();
  var _useAbandonmentTracki = useAbandonmentTracking(),
    startAbandonmentTracking = _useAbandonmentTracki.startAbandonmentTracking,
    completeAbandonmentTracking = _useAbandonmentTracki.completeAbandonmentTracking;
  var _useState2 = useState(false),
    hasUserStartedCheckoutForm = _useState2[0],
    setHasUserStartedCheckoutForm = _useState2[1];
  var bnplFlags = useMemo(function () {
    var bnplTypes = new Set(((checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.bnpl_options) || []).map(function (option) {
      return option.type;
    }));
    return ["tamara", "tabby", "amwal"].reduce(function (acc, type) {
      acc["is_".concat(type)] = bnplTypes.has(type) ? "yes" : "no";
      return acc;
    }, {});
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.bnpl_options]);
  useEffect(function () {
    if (!(formData !== null && formData !== void 0 && formData.city_id) && checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.city_id) {
      setFormItem("city_id", checkoutOrder.city_id);
    }
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.city_id]);
  useEffect(function () {
    if (checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.id) {
      fetch__getOrderWithPaymentInfo(post_id, checkoutOrder.id);
    }
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id]);
  useEffect(function () {
    if (!post_id || !(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.g4_data_layer)) return;
    if (hasUserStartedCheckoutForm) return;
    var g4Data = (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer) || {};
    startAbandonmentTracking({
      key: "add_to_cart_completed_cash_".concat(post_id),
      event: "add_to_cart_abandoned",
      shouldTrack: true,
      payload: _objectSpread(_objectSpread({}, g4Data), {}, {
        inventory_type: g4Data === null || g4Data === void 0 ? void 0 : g4Data.inventory_type_string,
        post_trim: g4Data === null || g4Data === void 0 ? void 0 : g4Data.post_ext
      }, bnplFlags)
    });
  }, [bnplFlags, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer, hasUserStartedCheckoutForm, post_id, startAbandonmentTracking, user === null || user === void 0 ? void 0 : user.id]);
  useEffect(function () {
    if (!hasUserStartedCheckoutForm || !post_id) return;
    completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
  }, [completeAbandonmentTracking, hasUserStartedCheckoutForm, post_id]);
  var completeCashCheckoutAbandonmentTracking = function completeCashCheckoutAbandonmentTracking() {
    completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
    completeAbandonmentTracking("start_checkout_abandoned_cash_".concat(post_id));
  };
  var verifyOtpCb = function verifyOtpCb(userData) {
    var _useLocalStorage = useLocalStorage(),
      setLocalStorage = _useLocalStorage.setLocalStorage;
    setLocalStorage("otp_visited_".concat(checkoutOrder.id), "1");
    if (!isLoggedIn) {
      handleHasAccountEvent({
        hasAccount: userData.has_account,
        status: "Success",
        phone_number: formData.phone_number,
        lang: lang,
        referral_location: "cash_order"
      });
    }
    completeCashCheckoutAbandonmentTracking();
    navigateTo("/checkout/create-araboon?post_id=".concat(post_id, "&order_id=").concat(checkoutOrder.id));
  };
  var main_render = function main_render() {
    if (showOtp) {
      return /*#__PURE__*/React.createElement(OtpVerification, {
        FIX_ME__extra_params: {
          order_id: normalizeIdNumber(checkoutOrder.id)
        },
        source: "cash_order_verify",
        after_verify_callback: verifyOtpCb,
        scenario: "signup",
        phone_number: formData.phone_number,
        onEditNumber: function onEditNumber() {
          setShowOtp(false);
        },
        design: {
          btnText: tShort("phone_number_verification", {
            "ns": "otp_screen"
          }),
          label: tShort("enter_code_sent_to", {
            "ns": "otp_screen"
          }),
          className: stl.otpWrapper,
          subClassName: stl.fontSize,
          otpBtn: stl.otpBtn
        }
      });
    }
    return /*#__PURE__*/React.createElement(ShopApplyForm, {
      loading: fetch_loading,
      setHasUserStartedCheckoutForm: setHasUserStartedCheckoutForm,
      setShowOtp: setShowOtp,
      onClickInfoIcon: grantedPopup.setTrue
    });
  };
  return /*#__PURE__*/React.createElement(Layout, {
    disableLoader: true,
    loading: fetch_loading,
    authenticationMsg: true,
    mainClass: "CheckOut",
    logoNotClickable: true,
    headHideLinks: true,
    hideMenu: true,
    hideAppBanner: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobileHeaderwithCancleFunction, {
      title: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_title,
      buttonFunction: function buttonFunction() {
        var _checkoutOrder$g4_dat, _checkoutOrder$g4_dat2;
        if (showOtp) {
          setShowOtp(false);
          return;
        }
        trackEvents(hasUserStartedCheckoutForm ? "start_checkout_abandoned" : "add_to_cart_abandoned", _objectSpread(_objectSpread({}, (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer) || {}), {}, {
          inventory_type: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat === void 0 ? void 0 : _checkoutOrder$g4_dat.inventory_type_string,
          post_trim: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat2 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat2 === void 0 ? void 0 : _checkoutOrder$g4_dat2.post_ext,
          booking_type: "cash"
        }, bnplFlags));
        completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
        completeAbandonmentTracking("start_checkout_abandoned_cash_".concat(post_id));
        // fixme, not working, is it still needed?
        navigateTo("/cardetail/".concat(post_id));
      }
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CancelButton, {
    onClick: function onClick() {
      var _checkoutOrder$g4_dat3, _checkoutOrder$g4_dat4;
      if (showOtp) if (showOtp) {
        setShowOtp(false);
        return;
      }
      trackEvents(hasUserStartedCheckoutForm ? "start_checkout_abandoned" : "add_to_cart_abandoned", _objectSpread(_objectSpread({}, (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer) || {}), {}, {
        inventory_type: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat3 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat3 === void 0 ? void 0 : _checkoutOrder$g4_dat3.inventory_type_string,
        post_trim: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat4 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat4 === void 0 ? void 0 : _checkoutOrder$g4_dat4.post_ext,
        booking_type: "cash"
      }, bnplFlags));
      completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
      completeAbandonmentTracking("start_checkout_abandoned_cash_".concat(post_id));
      navigateToHard("/cardetail/".concat(post_id));
    },
    className: "".concat(stl.CancelButton, " m-hide")
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement(HeadingSteps, null, /*#__PURE__*/React.createElement("span", {
    className: showOtp ? "completed" : "active"
  }, tShort("steps/add_information")), !isLoggedIn && /*#__PURE__*/React.createElement("span", {
    className: showOtp ? "active" : ""
  }, tShort("steps/otp_verification")), /*#__PURE__*/React.createElement("span", null, tShort("steps/payment"))), main_render())), /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-container",
    className: "m-hide"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.stickyContainer
  }, isDesktop && /*#__PURE__*/React.createElement(PaymentInfo, {
    loading: !checkoutOrder,
    checkoutOrder: checkoutOrder,
    referralData: referralData,
    className: stl.desktopCarInfo,
    onClickInfoIcon: grantedPopup.setTrue,
    showWarrantyWidget: isDesktop && !showOtp,
    orderType: "cash",
    onWarrantySelected: (/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              setFormItem("v_warranty_id", id);
              _context.n = 1;
              return fetch__getOrderDetailsByParams({
                warranty_id: id,
                city_id: String((formData === null || formData === void 0 ? void 0 : formData.city_id) || "")
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())
  }), checkoutOrder && checkoutOrder.post_is_new != 1 && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.is_warranty_10_day) && /*#__PURE__*/React.createElement(NDayGuarantee, {
    img: CDN_LINK + "/assets/images/dm10.svg"
  }))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: grantedPopup.value,
    onClose: grantedPopup.setFalse,
    containerClassName: "!z-[999999999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-8 p-[13px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/infoOrange.svg",
    width: "96px",
    height: "82px",
    alt: "icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#3C56D4] text-center text-[32px] font-bold leading-[32px]"
  }, t("shipping_cost_2", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#3C56D4] text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
  }, t("shipping_cost_determined_sales_representative", {
    ns: "web_checkout_cash"
  }))))));
};
export default ShopApply;